import './Footer.scss'

const Footer = () => {
  return (
    <footer className='footer'> <div className='footer__container'>© 2022  Andrea Simental </div></footer>
  )
}

export default Footer